
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic07Off as ObiHydraulic07OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-07-off.js';
 
 
 

 
 export const ObiHydraulic07Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-07-off',
   elementClass: ObiHydraulic07OffElement,
   events: {
     
   }
  });
 
 